export default class ListContainerSearch {
  constructor($listContainerSearch) {
    this.$listContainerSearch = $listContainerSearch;
    this.$listContainerHeader = this.$listContainerSearch.querySelector('.list-container__header');
    this.$listContainerFilterForm = this.$listContainerSearch.querySelector('.list-container__filter-form');
    this.$listContainerTabBar = this.$listContainerSearch.querySelector('.tab-bar');
    this.$listContainerHiglightHiddenField = this.$listContainerSearch.querySelector('[id="formHighlight"]');

    if (this.$listContainerHiglightHiddenField) {
      this.focusByHiddenFieldValue();
      this.setHiddenFieldValue();
    }

    this.focusByHash();
  }

  setHiddenFieldValue() {
    const $formElements = this.$listContainerFilterForm.querySelectorAll('input:not([type=hidden]), select, textarea, button');

    $formElements.forEach(($el) => {
      $el.addEventListener('focus', (event) => {
        this.$listContainerHiglightHiddenField.setAttribute('value', event.target.id);
      });
    });
  }

  setFocus($el) {
    let $focusEl = $el;
    let listContainerSearchContentElRect =
      this.$listContainerFilterForm.getBoundingClientRect();

    if (this.$listContainerHeader) {
      listContainerSearchContentElRect =
        this.$listContainerHeader.getBoundingClientRect();
    }

    setTimeout(() => {
      if (this.$listContainerTabBar) {
        const tabBarIsMenu = this.$listContainerTabBar.classList.contains('tab-bar--menu');
        if (tabBarIsMenu) {
          const focusElIsInsideMenu = this.$listContainerTabBar.contains($focusEl);
          if (focusElIsInsideMenu) {
            $focusEl = this.$listContainerTabBar.querySelector('.tab-bar__select');
          }
        }
      }
      $focusEl.focus();
      $focusEl.classList.add('focus-visible', 'focus-within');
      window.scrollTo(0, listContainerSearchContentElRect.y - 10);
    });
  }

  focusByHiddenFieldValue() {
    const hiddenFieldValue = this.$listContainerHiglightHiddenField.value;
    if (hiddenFieldValue) {
      const $focusEl = document.getElementById(hiddenFieldValue);
      if ($focusEl) {
        this.setFocus($focusEl);
      }
    }
  }

  focusByHash() {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);

      if (hash) {
        const $focusEl = document.getElementById(hash);
        if ($focusEl) {
          this.setFocus($focusEl);
        }
      }
    }
  }
}

// Init
document.querySelectorAll('.js-list-container-search').forEach($listContainerSearch => new ListContainerSearch($listContainerSearch));
